<template>
  <b-row align-h="center">
    <h2>Privacy policy</h2>
    <b-row>
      <b-col sm="12">
        We do NOT collect any personal data while you use any of the application functions or when you browse through the pages of this web and we do NOT use cookies to collect personal information or to track your browsing behaviour.
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-button variant="light" :to="{name: 'login'}"> &lt; Back to Login</b-button>
      </b-col>
    </b-row>
  </b-row>
</template>

<script>

export default {
  data() {
    return {
      storeDispatchTarget: 'AuthStore/privacyPage',
      routerTarget: { name: 'privacy' },
    };
  },
};
</script>
